// extracted by mini-css-extract-plugin
module.exports = {"self":"Status_self__pdTfD","icon":"Status_icon__NsieG"};